import { LogLevelDesc } from 'loglevel';

import { DevOptions } from './dev-options.model';
import { setLogLevel } from './log-level';

import { version } from './../../package.json';
import { PollingManager } from '../polling-manager/polling-manager';
import { CookieManager } from '../browser-utilities/cookie-manager';

export const devOptions: DevOptions = {
  version: version,
  log: (level: LogLevelDesc) => {
    // Default log level is 'warn'
    setLogLevel(level);
  },
  disablePolling: (value: boolean) => {
    PollingManager.disablePolling(value);
  },
  enableDebug: (value: boolean) => {
    if (value) {
      CookieManager.setCookie('ce.debug', 'true', {
        maxAge: '604800' // one week
      });
    } else {
      CookieManager.deleteCookie('ce.debug');
    }
  },
  q: { push: (value: unknown) => { window[window.CrossEngageObject](value); }}
};